/**
 * Public API block exports.
 *
 * @experimental This API is under active development and may change or be removed
 * in future releases without prior notice. Use with caution in production environments.
 */

// Public API for plugin developers

export { block } from "discourse/lib/blocks/-internals/decorator";
export { BlockCondition } from "discourse/blocks/conditions";
export type {
  ArgSchema,
  ArgType,
  BlockClassNames,
  BlockConstraints,
  BlockMetadata,
  BlockNamespaceType,
  BlockOptions,
  BlockValidateFn,
  ChildArgSchema,
  LayoutEntry,
} from "discourse/blocks/types";
